import { UserSchema } from '@retro-ui/prisma';
import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();
const pathPrefix = '/auth';

const DocumentSchema = z.object({
  name: z.string(),
  required: z.boolean(),
  url: z.string(),
});

const AuthUserSchema = UserSchema.extend({
  isLoggedIn: z.boolean(),
  unsignedDocuments: z.array(DocumentSchema),
  permissions: z.array(z.string()),
  organizationName: z.string(),
});

export const authContract = c.router(
  {
    getUser: {
      method: 'GET',
      path: '/user',
      responses: {
        200: z.union([AuthUserSchema, AuthUserSchema.pick({ isLoggedIn: true })]),
      },
    },
  },
  {
    pathPrefix,
    validateResponseOnClient: true,
  }
);
